import {createFeatureSelector, createSelector} from '@ngrx/store';
import {MapNgrx} from '~model/ngrx/map-ngrx';

export const featureKeyMap = 'map-ol';

export const selectFeature = createFeatureSelector<MapNgrx>(featureKeyMap);
export const loadResizeMap = createSelector(selectFeature, (state) => state.resizeMap);
export const loadMarkers = createSelector(selectFeature, (state) => ({markers: state.markers, clear: state.clear}));
export const loadPolygons = createSelector(selectFeature, (state) => ({polygons: state.polygons, clear: state.clear}));
export const mapLoadDetails = createSelector(selectFeature, (state) => state.details);
export const mapLoadSelectedGroups = createSelector(selectFeature, (state) => state.selectedGroups);
